const strings = {
  toasts: {
    statusChangedTitle: 'Status Change',
    statusChangedBody: `You have been set 'Unavailable' due to missing calls.`,
    refreshUserStatusFailure: 'Failed to refresh user status, please try again',
    refreshUserStatusSuccess: 'User status refreshed',
    setUserStatusFailure: 'Status change could not be completed.',
    cancelWrapupFailure:
      'We encountered an error while trying to skip wrap-up.',
  },
  refreshConfirmationModal: {
    title: 'Refresh user status?',
    body: 'If you are on a call, then refreshing user status will end that call. Are you sure you want to continue?',
    primaryText: 'Yes, refresh user status',
    secondaryText: 'Cancel',
  },
  tooltips: {
    noSeat:
      'A user seat is required to use this feature. Please contact your Administrator.',
    wrapUp:
      'You cannot change the status while in wrap-up. Please wait until it is finished.',
    cannotChange: 'User status cannot be changed',
  },
} as const;

export default strings;
